import './App.css'
import { Suspense, lazy } from 'react'
import Spinner from './components/layout/spinner/spinner'
import { Routing } from './components/shared/constants/routing'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import MainLayout from './components/layout/MainLayout'
import { ToastContainer } from 'react-toastify'
const Login = lazy(() => import('./components/pages/auth/Login'))
const Dashboard = lazy(() => import('./components/pages/deshboard/Dashboard'))
const ImportData = lazy(() => import('./components/pages/ImportData/ImportData'))
const Creators = lazy(() => import('./components/pages/creators/Creators'))
const Agents = lazy(() => import('./components/pages/agents/Agents'))
const ChangeLanguage = lazy(() => import('./components/pages/changeLanguage/changeLanguage'))

const routes = [
  {
    path: Routing.Initial,
    component: Login,
    isPrivateRoute: true,
  },
  {
    path: Routing.Login,
    component: Login,
    isPrivateRoute: true,
  },
  {
    path: Routing.Dashboard,
    component: Dashboard,
    isPrivateRoute: true,
  },
  {
    path: Routing.Creators,
    component: Creators,
    isPrivateRoute: true,
  },
  {
    path: Routing.Agents,
    component: Agents,
    isPrivateRoute: true,
  },
  {
    path: Routing.ImportData,
    component: ImportData,
    isPrivateRoute: true,
  },
  {
    path: Routing.changeLanguage,
    component: ChangeLanguage,
    isPrivateRoute: true,
  },
]

function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <Router>
        {/* <Routes>
          {routes.filter((route) => !route.isPrivateRoute)
            .map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<route.component />}
                />
              );
            })}
        </Routes> */}
        <Routes>
          {routes
            .filter((route) => route.isPrivateRoute)
            .map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <MainLayout>
                      <route.component />
                    </MainLayout>
                  }
                />
              )
            })}
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={5000} />
    </Suspense>
  )
}

export default App
